module.exports = __webpack_public_path__ + "static/media/IA_i.0550c096.jpg";